import { RouteType } from "types/RouteType";
import EquipmentMaintenanceWorkflowStore from "./EquipmentMaintenanceWorkflowStore";

const EquipmentMaintenanceWorkflowRoute: RouteType = {
  name: "Equipment Maintenance Workflow",
  path: "/workflows/equipment-maintenance",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Equipment Maintenance",
      component: () => import("./EquipmentMaintenanceWorkflowHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./EquipmentMaintenanceWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.equipmentMaintenanceWorkflowStore) {
      rootStore.equipmentMaintenanceWorkflowStore = new EquipmentMaintenanceWorkflowStore(
        rootStore
      );
    }
    const store = rootStore.equipmentMaintenanceWorkflowStore as EquipmentMaintenanceWorkflowStore;
    await store.loadInitialData();
    return true;
  },
};

export default EquipmentMaintenanceWorkflowRoute;